
import axios from 'utils/axios';
import {dispatch, store} from 'store';

import {createSlice} from '@reduxjs/toolkit';
import { InvoiceOutstandingProps } from 'types/props-obj/InvoiceOutstandingProps';

const initialState: InvoiceOutstandingProps = {
    apiEndPoint: "invoice-reports",
    pageLimit: 5,
    pageNumber: 1,
    isOpen: false,
    total_amount_outstanding:0,
    list: [],
    item: null,
    error: null,
    alertPopup: false,
};

const invoiceOutstanding = createSlice({
    name: initialState.apiEndPoint+'',
    initialState,
    reducers: {
        hasError(state, action) {
            state.error = action.payload.error;
        },
        setPageNumber(state, action) {
            state.pageNumber = action.payload;
        },
        setPageLimit(state, action) {
            state.pageLimit = action.payload;
        },
        // get all Item list
        getList(state, action) {
            state.list.push(action.payload);
            state.list = state.list.filter((liste) => liste.id !== 0);
            state.isLoading=false;
        },
        alertPopupToggle(state, action) {
            state.alertPopup = action.payload.alertPopup;
        },
        openToggle(state, action) {
            state.isOpen = action.payload.isOpen;
        },
        // get Item details
        setItem(state, action) {
            state.item = action.payload;
            state.isLoading=false;
        },

        // GET Items
        setItemsSuccess(state, action) {
            state.list = action.payload.data;
            state.current_page=action.payload.current_page;
            state.last_page=action.payload.last_page;
            state.total=action.payload.total;
            state.total_amount_outstanding=action.payload.total_amount_outstanding;
            state.isLoading=false;
        },

        // ADD Item
        addItemSuccess(state, action) {
            state.list = [...state.list,action.payload];
            state.isLoading=false;
        },

        // EDIT Item
        editItemSuccess(state, action) {
            var foundIndex = state.list.findIndex(x => x.id === action.payload.id);
            state.item=action.payload;
            state.list[foundIndex] = action.payload;
            state.isLoading=false;
        },

        deleteItemSuccess(state, action) {
            state.list = state.list.filter((item) => item.id !== action.payload);
        },



        setApiEndPoint(state, action) {
            state.apiEndPoint = action.payload;
        },
        setLoading(state, action) {
            state.isLoading = action.payload;
        },

    }
});


export default invoiceOutstanding.reducer;

function getApiEndPoint(){
    return store.getState().invoiceOutstanding.apiEndPoint
}

export const { alertPopupToggle,openToggle,setPageNumber,setLoading,setPageLimit,setApiEndPoint } = invoiceOutstanding.actions;
export function getList(params:any={}) {
    return async () => {
        dispatch(invoiceOutstanding.actions.setLoading(true));
        try {
           
            
            const response = await axios.get(getApiEndPoint(),{params:params});
            dispatch(invoiceOutstanding.actions.setItemsSuccess(response.data));
        } catch (error) {
            dispatch(invoiceOutstanding.actions.hasError(error));
        }
    };
}

export function getItem(id: number | undefined) {
    return async () => {
        dispatch(invoiceOutstanding.actions.setLoading(true));

        try {
            const response = await axios.get([getApiEndPoint(),  id].join('/'));
            dispatch(invoiceOutstanding.actions.setItem(response.data));
        } catch (error) {
            dispatch(invoiceOutstanding.actions.hasError(error));
            dispatch(invoiceOutstanding.actions.setLoading(false));
        }
    };
}

export function addItem(ls:any) {
    return async () => {
        dispatch(invoiceOutstanding.actions.setLoading(true));
        try {
            const response = await axios.post(getApiEndPoint(), ls);
            dispatch(invoiceOutstanding.actions.addItemSuccess(response.data));
        } catch (error) {
            dispatch(invoiceOutstanding.actions.hasError(error));
            dispatch(invoiceOutstanding.actions.setLoading(false));
        }
    };
}

export function editItem(id: number | undefined,ls: any) {
    return async () => {
        dispatch(invoiceOutstanding.actions.setLoading(true));
        try {
            const response = await axios.put([getApiEndPoint(),  id].join('/'), ls);
            dispatch(invoiceOutstanding.actions.editItemSuccess(response.data));
        } catch (error) {
            dispatch(invoiceOutstanding.actions.hasError(error));
            dispatch(invoiceOutstanding.actions.setLoading(false));
        }
    };
}

export function deleteItem(id: number | undefined) {
    return async () => {
        try {
            await axios.delete([getApiEndPoint(),  id].join('/'));
            dispatch(invoiceOutstanding.actions.deleteItemSuccess(id));
        } catch (error) {
            dispatch(invoiceOutstanding.actions.hasError(error));
        }
    };
}

